import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { GroupRequest, InstitutionGroup, MemberRequest } from '../interfaces/intercompany.interface';

const E = ENDPOINTS.INSTITUTION_GROUP;

export const InstitutionGroupService = {
  list: async (): Promise<InstitutionGroup[]> => (await axios.get(E.BASE)).data,
  create: async (body: GroupRequest): Promise<InstitutionGroup> => (await axios.post(E.BASE, body)).data,
  update: async (id: string, body: GroupRequest): Promise<InstitutionGroup> => (await axios.put(E.ONE(id), body)).data,
  addMember: async (id: string, body: MemberRequest): Promise<InstitutionGroup> => (await axios.post(E.MEMBERS(id), body)).data,
  removeMember: async (id: string, memberId: string): Promise<InstitutionGroup> => (await axios.delete(E.MEMBER(id, memberId))).data,
  mine: async (institutionId: string): Promise<InstitutionGroup | null> => {
    const res = await axios.get(E.MINE(institutionId));
    return res.status === 204 || !res.data ? null : res.data;
  },
};
